import { AnimationDuration } from "@uno/protocol";
import { AnimationValue } from "../types/Animation";

const RevealRoomPlayerCardsAnimation = (): AnimationValue => {
    return {
        effects: [{
            el: ".card-inner",
            transform: [
                "rotateY(-180deg)",
                "rotateY(0deg)"
            ],
        }],
        transitions: [{ duration: AnimationDuration.RevealRoomPlayerCards, fill: "backwards" }],
        duration: AnimationDuration.RevealRoomPlayerCards,
    }
};

export default RevealRoomPlayerCardsAnimation;
